import { render, staticRenderFns } from "./r-item-config.vue?vue&type=template&id=1737b4c0&scoped=true"
import script from "./r-item-config.vue?vue&type=script&lang=js"
export * from "./r-item-config.vue?vue&type=script&lang=js"
import style0 from "./r-item-config.vue?vue&type=style&index=0&id=1737b4c0&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1737b4c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1737b4c0')) {
      api.createRecord('1737b4c0', component.options)
    } else {
      api.reload('1737b4c0', component.options)
    }
    module.hot.accept("./r-item-config.vue?vue&type=template&id=1737b4c0&scoped=true", function () {
      api.rerender('1737b4c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item/r-item-config.vue"
export default component.exports